import { useEffect, useState } from "react";

const MOBILE_BREAKPOINT = 768;

// true cuando el ancho de la ventana es menor al breakpoint móvil.
// Se recalcula en cada resize (rotar tablet, redimensionar ventana) —
// a diferencia de `const isMobile = window.innerWidth < 768`, que solo
// se evalúa una vez y queda congelado hasta recargar la página.
export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < MOBILE_BREAKPOINT);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
};
